import React from "react";
import { Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import SearchBar from "../components/SearchBar";
import useMediaQuery from "@mui/material/useMediaQuery";
import CategoryCard from "../components/CategoryCard";
import { useTranslation } from "react-i18next";
import StudentIcon from "../img/icons/student.svg"
import HouseIcon from "../img/icons/house.svg";
import CarIcon from "../img/icons/car.svg";
import LeisureIcon from "../img/icons/leisure.svg";

import "./NieuweCheck.css";

const categories = [
  {
    id: "587ddfe9-4d1e-4c38-b3dc-a97a32976461",
    name: "Wonen",
    modules: [
      {
        id: "3e49afb2-d3d2-4049-a12a-dd729b5c8d39",
        name: "Woning huren",
        description: "Ik ga een woning huren",
        isReleased: true,
        uriName: "rent",
        icon: <img src={HouseIcon} alt="Student Icon" style={{ width: '24px', height: '24px' }} />,
      },
      {
        id: "45f4ac25-cd45-4c37-9114-e418c7f24b84",
        name: "Studentenwoning huren",
        description: "Ik ga een studentenwoning huren",
        isReleased: true,
        uriName: "student_rent",
        icon: <img src={StudentIcon} alt="Student Icon" style={{ width: '24px', height: '24px' }} />,
      },
      {
        id: "ce7cd166-e28e-4d28-8b55-69e561f188ad",
        name: "Woning kopen",
        description: "Ik ga een woning kopen",
        isReleased: true,
        uriName: "buy",
        icon: <img src={HouseIcon} alt="House Icon" style={{ width: '24px', height: '24px' }} />,
      },
      {
        id: "c457e38a-0475-46b2-ba8a-1a5d5c591a2c",
        name: "Woning verhuren",
        description: "Ik ga mijn woning verhuren",
        isReleased: false,
        uriName: "lease",
      },
    
    ],
    imgPath: "img/wonen.png",
    uriName: "housing",
  },
  {
    id: "7262b7c5-d890-4d86-a3ff-41f1347e5e45",
    name: "Vervoer",
    modules: [
      {
        id: "0874e8bc-a58f-4474-b0d1-b536fc40bfeb",
        name: "Occasion kopen",
        description: "Ik ga een occasion kopen",
        isReleased: true,
        uriName: "car-occasion",
        icon: <img src={CarIcon} alt="Student Icon" style={{ width: '24px', height: '24px' }} />,
      },
    ],
    imgPath: "img/vervoer.png",
    uriName: "transport",
  },
  {
    id: "f2bff57f-cc1a-4acd-94a4-24fef519dfc2",
    name: "Vrije tijd en sport",
    modules: [
      {
        id: "2995209f-fa61-4404-a4b8-a9ae9b6bf715",
        name: "Abonnement sportschool",
        description: "Ik wil een abonnement bij een sportschool",
        isReleased: false,
        uriName: "gym-contract",
        icon: <img src={LeisureIcon} alt="Student Icon" style={{ width: '24px', height: '24px' }} />,
      },
    ],
    imgPath: "img/vrije-tijd-sport.png",
    uriName: "leisure-and-sports",
  },
];

const NieuweCheck = () => {
  const theme = useTheme();
  const { t } = useTranslation();

  const mobile = useMediaQuery(theme.breakpoints.between("mobile", "ipad"));
  const tablet = useMediaQuery(theme.breakpoints.between("ipad", "laptop"));

  return (
    <div className="new-check-container">
      <div className={`new-check-top ${mobile || tablet ? "mobile" : ""}`}>
        <Typography
          variant={mobile || tablet ? "h4" : "h3"}
          sx={{
            color: "#439BD9",
          }}
        >
          {t("selectACategory")}
        </Typography>

        <SearchBar />
      </div>

      <div className="category-cards-container">
        {/* {getCategoriesLoading && <CircularProgress />} */}
        {categories.length > 0 &&
          categories.map((category, index) => (
            <CategoryCard key={index} category={category} />
          ))}
      </div>
    </div>
  );
};

export default NieuweCheck;
